import styled from 'styled-components'
import { StyledVehicleDetailImage } from './VehicleDetailImage.style'
import { zIndex } from 'common/constants'

export const StyledVehicleDetailsGridCardImage = styled(StyledVehicleDetailImage)`
  img {
    max-width: inherit;
    max-height: 22rem;

    object-fit: cover;
    object-position: center;

    &.img-err {
      object-fit: contain;
    }
  }

  .pill {
    border-radius: 0.5rem 0.5rem;
    padding: 0 0.5rem;
  }

  .page-indicator {
    position: absolute;
    z-index: ${zIndex.floatingControls};
    right: 0;
    margin: 0.5rem;
    background: #808080;
    color: #f0f0f0;
  }

  .carousel {
    .carousel-item {
      span {
        width: 100%;
      }

      img,
      span {
        height: 100%;
      }
    }

    a[class^='carousel-control-'] {
      width: 8%;
      opacity: 1;

      &:hover {
        opacity: 0.5;
      }
    }
  }
  .img-load-err {
    cursor: default;
  }
`
